import { DomainLevel } from "apps/platform-client/client/src/models/enums/enums";
import { DomainType, sortDomainsByName } from "./components/DomainCard";

type DomainFamily = {
	currentDomain: DomainType | undefined;
	parent: DomainType | null | undefined;
	siblings?: DomainType[];
};

export function findDomainById(domains: DomainType[] | undefined, id: string, parent?: DomainType): DomainFamily {
	if (!domains) {
		return { currentDomain: undefined, parent: undefined, siblings: undefined };
	}

	const sortedDomainAndSubdomains = sortDomainsByName(domains as DomainType[]);

	for (const domain of sortedDomainAndSubdomains) {
		if (domain.id === id) {
			const siblings = sortedDomainAndSubdomains.filter((d) => d.id !== domain.id);

			return { currentDomain: domain, parent, siblings };
		}

		// search in children
		const inChild = findDomainById(domain.children, id, domain);

		if (inChild.currentDomain) {
			return inChild;
		}
	}

	return { currentDomain: undefined, parent: undefined, siblings: undefined };
}

export const isGlobalOrProductUser = (
	domains: {
		id: string;
		level: number;
	}[]
): boolean => domains.some((d) => d.level == DomainLevel.GLOBAL || d.level == DomainLevel.PRODUCT);
